import {updatePropertyPreferences} from 'api/propertyPreferences';

const RESET = 'pulp/reportType/RESET';

export const initialState = {value: 'cma', priority: false};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case RESET:
      return action.payload;
    default:
      return state;
  }
}

export function resetReportType(value, {priority = false, savePreference = false} = {}) {
  return (dispatch, getState) => {
    const {
      propertyDetail: {propertyId},
      reportType: {priority: existingPriority},
    } = getState();

    if (priority || !existingPriority) {
      if (savePreference && propertyId) {
        updatePropertyPreferences(propertyId, {reportType: value});
      }

      dispatch({
        type: RESET,
        payload: {value, priority},
      });
    }
  };
}